module.exports = __webpack_public_path__ + "static/media/illustration.29f924ff.svg";